<div class="head-permission inline-block">
    <div width="50%" class="inline-block;">
        <p class="section-title">
            Create permission sets that define what users have the ability to access in Nexus
            Vision.
        </p>
    </div>
    <div width="50%" class="float-right inline-block">
        <div class="employee-add-button-area float-right">
            <button type="button" mat-raised-button (click)="addNew()">
                <i class="fal fa-plus-square" A></i>
                &nbsp; ADD NEW
            </button>
        </div>
    </div>
</div>

<br />
<br />
<table class="permission-table">
    <thead>
        <tr>
            <th>Name</th>
            <th>Modules</th>
            <th>Positions</th>
            <th>Users</th>
            <th id="permission-table-settings"></th>
        </tr>
    </thead>

    <tbody>
        <tr *ngIf="isPageLoaded && (!data || data.length === 0)">
            <td colspan="4">
                <div class="no-data-message-area">
                    <no-data-screen [noDataType]="noDataType"></no-data-screen>
                </div>
            </td>
        </tr>
        <tr *ngIf="!data && !isPageLoaded">
            <td colspan="4">
                <spin-loader [type]="'bounce'"></spin-loader>
            </td>
        </tr>
        <tr *ngFor="let row of data" [hidden]="row.isDeleted == true">
            <td class="td-link" (click)="clickPermissionSet(row)">
                {{ row.name }}
            </td>
            <td>
                <span *ngFor="let access of row.access; let i = index">
                    {{ access }}
                    <span *ngIf="i < row.access?.length - 1"> | </span>
                </span>
                <span *ngIf="!row.access || row.access.length < 1">None</span>
            </td>
            <td>
                <span *ngIf="row.positions">{{ row.positions }}</span>
                <span *ngIf="!row.positions">None</span>
            </td>
            <td>
                <span *ngIf="row.numUsers" (click)="showAssignedUsers(row)" class="td-link">{{
                    row.numUsers
                }}</span>
                <span *ngIf="!row.numUsers">0</span>
            </td>
            <td>
                <button
                    mat-stroked-button
                    color="warn"
                    (click)="deletePermissionSet(row, row.permissionSetKey, row.name)"
                    [ngStyle]="{
                        border: row.numUsers > 0 ? 'none' : '1px solid rgba(0, 0, 0, 0.12)'
                    }"
                    [disabled]="row.numUsers > 0"
                >
                    Delete
                </button>
            </td>
        </tr>
    </tbody>
</table>

<div id="permission-background" *ngIf="newPermissionMenu">
    <div id="permission-menu">
        <div id="permission-menu-header">
            <span *ngIf="permissionSetKey === 0">Add </span>
            <span *ngIf="permissionSetKey !== 0">Edit </span>
            <span>Permission Set</span>
            <span (click)="exit()" style="float: right; padding-right: 15px; cursor: pointer">
                <i class="fas fa-times"></i>
            </span>
        </div>

        <br />
        <div id="permission-menu-body">
            <div style="width: 50%">
                <mat-form-field fluid appearance="outline" class="example-full-width">
                    <mat-label>Permission Set Name</mat-label>
                    <input matInput [(ngModel)]="setName" (input)="typeName()" />
                </mat-form-field>
            </div>

            <br /><br />
            <mat-tab-group
                *ngIf="!smallScreen"
                ActiveTabIndex="0"
                (selectedTabChange)="logTab($event)"
                fixed
                stacked
            >
                <ng-container *ngFor="let tab of moduleTabs">
                    <mat-tab [label]="tab.label">
                        <!-- <mat-icon fontSet="fa" [fontIcon]="tab.icon" class="fa-2x"></mat-icon> -->
                    </mat-tab>
                </ng-container>
            </mat-tab-group>

            <div class="scroller-alt">
                <button mat-button *ngFor="let tab of moduleTabs" (click)="clickTab(tab)">
                    <mat-icon fontSet="fa" [fontIcon]="tab.icon" class="fa-2x"></mat-icon>
                    <mat-label>{{ tab.label }}</mat-label>
                </button>
            </div>
            <br />

            <ng-container *ngFor="let module of moduleData">
                <app-permission-set-pages
                    [modules]="module"
                    (updatePage)="clickGrantAccess($event)"
                    *ngIf="isActiveTab(module.page.name)"
                ></app-permission-set-pages>
            </ng-container>

            <br /><br />

            <!-- Validators -->
            <div id="name-validators" style="float: left">
                <div id="existence-validator">
                    <div *ngIf="!setName" class="field-incorrect">
                        <p>
                            <i class="fas fa-times"></i>
                            Permission Set Name is empty
                        </p>
                    </div>
                </div>
                <div id="length-less-validator" *ngIf="setName">
                    <div *ngIf="setName.length < 4" class="field-incorrect">
                        <p>
                            <i class="fas fa-times"></i>
                            Permission Set Name is too short
                        </p>
                    </div>
                </div>
                <div id="length-greater-validator" *ngIf="setName">
                    <div *ngIf="setName.length > 32" class="field-incorrect">
                        <p>
                            <i class="fas fa-times"></i>
                            Permission Set Name is too long
                        </p>
                    </div>
                </div>
                <div id="unique-validator" *ngIf="setName">
                    <div *ngIf="hasName" class="field-incorrect">
                        <p>
                            <i class="fas fa-times"></i>
                            Permission Set Name is taken
                        </p>
                    </div>
                </div>
            </div>

            <div width="150px" style="float: right; padding-top: 20px">
                <button mat-button (click)="exit()">Cancel</button>
                &nbsp;&nbsp;
                <button
                    mat-button
                    primary
                    (click)="update()"
                    [disabled]="!setName || setName.length <= 3 || hasName || savingData"
                >
                    Save &nbsp;
                    <i class="far fa-save"></i>
                </button>
            </div>
        </div>
    </div>
</div>
